module.exports = __webpack_public_path__ + "img/figma.bf8e3003.svg";